export const GET_LOGISTICS_PENDING = "GET_LOGISTICS_PENDING"
export const GET_LOGISTICS_SUCCESS = "GET_LOGISTICS_SUCCESS"
export const GET_LOGISTICS_FAILURE = "GET_LOGISTICS_FAILURE"

export const ADD_LOGISTICS_PENDING = "ADD_LOGISTICS_PENDING"
export const ADD_LOGISTICS_SUCCESS = "ADD_LOGISTICS_SUCCESS"
export const ADD_LOGISTICS_FAILURE = "ADD_LOGISTICS_FAILURE"

export const UPLOAD_LOGISTICS_PENDING = "UPLOAD_LOGISTICS_PENDING"
export const UPLOAD_LOGISTICS_SUCCESS = "UPLOAD_LOGISTICS_SUCCESS"
export const UPLOAD_LOGISTICS_FAILURE = "UPLOAD_LOGISTICS_FAILURE"

export const EDIT_LOGISTICS_PENDING = "EDIT_LOGISTICS_PENDING"
export const EDIT_LOGISTICS_SUCCESS = "EDIT_LOGISTICS_SUCCESS"
export const EDIT_LOGISTICS_FAILURE = "EDIT_LOGISTICS_FAILURE"

export const DELETE_LOGISTICS_PENDING = "DELETE_LOGISTICS_PENDING"
export const DELETE_LOGISTICS_SUCCESS = "DELETE_LOGISTICS_SUCCESS"
export const DELETE_LOGISTICS_FAILURE = "DELETE_LOGISTICS_FAILURE"

export const DOWNLOAD_LOGISTICS_PENDING = "DOWNLOAD_LOGISTICS_PENDING"
export const DOWNLOAD_LOGISTICS_SUCCESS = "DOWNLOAD_LOGISTICS_SUCCESS"
export const DOWNLOAD_LOGISTICS_FAILURE = "DOWNLOAD_LOGISTICS_FAILURE"
